import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";
import Link from "next/link";
import { useTranslations, useLocale } from "next-intl";
import { social } from "@/data";
import { cn } from "@/lib/utils";

type SocialProps = {
  className?: string;
}

function getSocialIcon(name: string) {
  switch (name) {
    case "GitHub":
      return <FaGithub />;
    case "LinkedIn":
      return <FaLinkedin />;
    case "X":
      return <FaXTwitter />;
    case "Contact":
      return <MdEmail />;
    default:
      return null;
  }
}

// Get accessibility label based on platform name
function getSocialAriaLabel(name: string, t: (key: string) => string) {
  switch (name) {
    case "GitHub":
      return t('githubProfile');
    case "LinkedIn":
      return t('linkedinProfile');
    case "X":
      return t('xProfile');
    case "Contact":
      return t('contact');
    default:
      return name;
  }
}

function Social({ className }: SocialProps) {
  const t = useTranslations('General');
  const locale = useLocale();
  
  return (
    <div className={cn("flex items-center gap-3 text-2xl", className)}>
      {social.map((item) => {
        // Handle locale-aware internal links
        const href = item.external 
          ? item.href 
          : (locale === 'en' ? `/${item.href}` : `/${locale}/${item.href}`);
        
        return (
          <Link 
            href={href} 
            target={item.external ? "_blank" : "_self"}
            key={item.name}
            aria-label={getSocialAriaLabel(item.name, t)}
            title={item.external ? `${t('visitOn')} ${item.name}` : getSocialAriaLabel(item.name, t)}
          >
            {getSocialIcon(item.name)}
          </Link>
        );
      })}
    </div>
  );
}

export default Social;
